import React, { useMemo } from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import { splitSafetyBlocks, summaryLabel } from "./safetyFold";
import { collapseLongAnswer } from "./answerCollapse";

// Answer markdown with standalone safety blocks folded under a visible amber line
// (safetyFold.js). Nothing is removed; the summary says what is folded and whether it
// contains a GEFAHR warning.
const FoldedMarkdown = ({ md, components, question, final = true }) => {
  // Safety blocks fold under an amber/red line (safetyFold.js); long list-like answers keep
  // their first ~150 words open and fold the rest into ONE neutral line that names what is
  // inside (answerCollapse.js). The collapse only runs on a finished answer (`final`): while
  // the answer streams the text grows and a fold would appear mid-stream.
  const segs = useMemo(() => {
    const out = [];
    for (const seg of splitSafetyBlocks(md, { question })) {
      if (seg.kind !== 'main' || !final) { out.push(seg); continue; }
      for (const p of collapseLongAnswer(seg.md)) out.push(p.kind === 'fold' ? { ...p, kind: 'more' } : p);
    }
    return out;
  }, [md, question, final]);
  return (
    <>
      {segs.map((seg, i) => {
        if (seg.kind === 'safety') {
          return (
            <details key={i} className={`safety-fold${seg.danger ? ' has-danger' : ''}`}>
              <summary>⚠️ {summaryLabel(seg)}</summary>
              <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{seg.md}</ReactMarkdown>
            </details>
          );
        }
        if (seg.kind === 'more') {
          return (
            <details key={i} className="answer-fold">
              <summary>{seg.title}</summary>
              <ReactMarkdown remarkPlugins={[remarkGfm]} components={components}>{seg.md}</ReactMarkdown>
            </details>
          );
        }
        return <ReactMarkdown key={i} remarkPlugins={[remarkGfm]} components={components}>{seg.md}</ReactMarkdown>;
      })}
    </>
  );
};

export default FoldedMarkdown;
